import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../../assets/css/timeTable.css';
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import Loader from '../../Shared/Loader/Loader';
import CommonConfig from '../../../utils/constant';
import moment from 'moment';

const EditClassTimeTable = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [subjectList, setSubjectList] = useState([]);
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [periodsList, setPeriodsList] = useState([]);
    const [editTableData, setEditTableData] = useState([]);
    const [originalEditTableData, setOriginalEditTableData] = useState([]);
    const [startDateValueErr, setStartDateValueErr] = useState(false);
    const [startDateValueErrText, setStartDateValueErrText] = useState('');
    const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [isAcademicYearApply, setIsAcademicYearApply] = useState(false);
    const [selectedYear, setSelectedYear] = useState(props?.location?.state?.financialYearId);
    const navigate = useNavigate();

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetSubjectList(loginData?._id);
        GetConfigurationData(loginData?._id);
        GetTimeTableData(props?.location?.state?.ClassId, loginData?._id, props?.location?.state?.startDate, props?.location?.state?.endDate, props?.location?.state?.configId);
    }, []);

    useEffect(() => {
        if (isAcademicYearApply) {
            const academicCalendar = props?.location?.state?.academicYearList || [];

            if (!academicCalendar.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const validRanges = academicCalendar.filter(
                item => item?.StartDate && item.EndDate && item?._id === selectedYear
            );

            if (!validRanges.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const sortedCalendar = [...validRanges].sort(
                (a, b) =>
                    new Date(a?.StartDate) - new Date(b?.StartDate)
            );

            const start = new Date(sortedCalendar[0]?.StartDate);
            const end = new Date(sortedCalendar[0]?.EndDate);

            setAcademicStartDate(start);
            setAcademicEndDate(end);
        }
    }, [selectedYear, props?.location?.state?.academicYearList, isAcademicYearApply]);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setIsAcademicYearApply(res?.data?.IsAcademicYearApply);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetSubjectList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getSubjectList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let subjectData = res?.data
                        ?.filter(y => y?.Status == 'Active' && y?.Classes?.split(',')?.includes(props?.location?.state?.ClassId))
                        ?.map(x => ({
                            TeachersList: x?.TeachersList,
                            label: x?.SubjectName,
                            value: x?._id,
                            isOptional: !!x?.IsOptional
                        }));
                    setSubjectList([...subjectData]);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTimeTableData = async (classId, userId, startDate, endDate, configId) => {
        try {
            let data = {
                ClassId: classId,
                FinancialYearId: selectedYear,
                StartDate: !CommonConfig.isEmpty(startDate) && startDate !== '-' ? moment(startDate).format("YYYY-MM-DD") : '',
                EndDate: !CommonConfig.isEmpty(endDate) && endDate !== '-' ? moment(endDate).format("YYYY-MM-DD") : '',
                UserId: userId,
                ConfigId: configId
            }
            Loader.show();
            const response = await api.post(APIConstant.path.GetTimeTableByClass, data);
            if (response?.success && response?.data.length > 0) {
                setStartDateValue(response?.data[0]?.StartDate ? new Date(response?.data[0]?.StartDate) : null);
                setEndDateValue(response?.data[0]?.EndDate ? new Date(response?.data[0]?.EndDate) : null);

                let periodTempData = response?.data[0]?.Periods?.map((x, idx) => {
                    return { Time: x?.Time, isBreak: x?.SubjectId === 'Break' ? true : false }
                });

                const periodData = periodTempData?.length && periodTempData?.map((period) => {
                    const times = period?.Time?.replace('Break - ', '')?.split(' - ');
                    const [from, to] = times?.map((time) => {
                        const match = time?.match(/(\d+):(\d+)\s(AM|PM)/);

                        if (!match) return null;

                        const [hours, minutes, ampm] = match;
                        const date = new Date();
                        date.setHours(ampm === 'PM' && hours !== '12' ? parseInt(hours, 10) + 12 : parseInt(hours, 10));
                        date.setMinutes(parseInt(minutes, 10));
                        return date;
                    });

                    return {
                        Time: period?.Time,
                        isEdit: false,
                        isBreak: period?.isBreak,
                        FromTime: from,
                        ToTime: to,
                    };
                });
                setPeriodsList(periodData);
                let timeTableEditData = response?.data?.map(row => {
                    const formattedRow = { Day: row?.Day, id: row?.id };
                    row?.Periods.forEach((period, index) => {
                        const special = period?.PeriodType === 'Remedial' || period?.PeriodType === 'Hobby';
                        formattedRow[`Period${index + 1}`] = special ? period?.PeriodType : period?.SubjectId;
                        formattedRow[`Teacher${index + 1}`] = period?.TeacherId;
                        formattedRow[`Parallel${index + 1}`] = (period?.ParallelSubjects || [])
                            .map(ps => ({ SubjectId: ps?.SubjectId || null, TeacherId: ps?.TeacherId || null }));
                    });
                    return formattedRow;
                });
                const EditsortedData = timeTableEditData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });

                setEditTableData(EditsortedData);
                setOriginalEditTableData(EditsortedData);
            } else {
                setPeriodsList([]);
                setEditTableData([]);
                setOriginalEditTableData([]);
                Toast.error({ message: response?.message });
            }
            Loader.hide();
        } catch (error) {
            Loader.hide();
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const handleDropdownChange = (e, rowData, period) => {
        const selectedSubject = subjectList.find(x => x?.value === e.value);
        const teachersList = selectedSubject?.TeachersList ?? [];
        const teacherKey = `Teacher${period.replace('Period', '')}`;
        const isPrimary = !period.endsWith('_2');

        const updatedData = editTableData.map(row => {
            if (row?.Day !== rowData?.Day) return row;

            const updatedRow = { ...row, [period]: e.value };
            // Auto-pick teacher when the subject has exactly one; otherwise reset
            // so a leftover teacher from the previous subject can't linger.
            updatedRow[teacherKey] = teachersList.length === 1 ? teachersList[0]?.id : null;

            if (isPrimary && !selectedSubject) {
                const idx = period.replace('Period', '');
                updatedRow[`Parallel${idx}`] = [];
            }
            return updatedRow;
        });

        const sortedData = [...updatedData].sort(
            (a, b) => days.indexOf(a?.Day) - days.indexOf(b?.Day)
        );

        setEditTableData(sortedData);
    };

    // Per-cell period type: Normal (real subject) / Remedial / Hobby. Remedial &
    // Hobby are labelled sessions (no subject/teacher) stored via PeriodType on save.
    const handlePeriodTypeChange = (rowData, periodIndex, type) => {
        const idx = periodIndex + 1;
        const updated = editTableData.map(row => {
            if (row?.Day !== rowData?.Day) return row;
            const r = { ...row };
            if (type === 'Remedial' || type === 'Hobby') {
                r[`Period${idx}`] = type;
                r[`Teacher${idx}`] = null;
                r[`Parallel${idx}`] = [];
            } else {
                if (r[`Period${idx}`] === 'Remedial' || r[`Period${idx}`] === 'Hobby') {
                    r[`Period${idx}`] = '';
                    r[`Teacher${idx}`] = null;
                    r[`Parallel${idx}`] = [];
                }
            }
            return r;
        });
        setEditTableData([...updated].sort((a, b) => days.indexOf(a?.Day) - days.indexOf(b?.Day)));
    };

    // Update the row for one day and re-sort (shared by the parallel-subject handlers).
    const updateDayRow = (rowData, mutate) => {
        const updated = editTableData.map(row => (row?.Day === rowData?.Day ? mutate({ ...row }) : row));
        setEditTableData([...updated].sort((a, b) => days.indexOf(a?.Day) - days.indexOf(b?.Day)));
    };

    const addParallelSubject = (rowData, periodIndex) => {
        const key = `Parallel${periodIndex + 1}`;
        updateDayRow(rowData, (row) => {
            const list = Array.isArray(row[key]) ? [...row[key]] : [];
            list.push({ SubjectId: null, TeacherId: null });
            row[key] = list;
            return row;
        });
    };

    const removeParallelSubject = (rowData, periodIndex, entryIndex) => {
        const key = `Parallel${periodIndex + 1}`;
        updateDayRow(rowData, (row) => {
            const list = Array.isArray(row[key]) ? [...row[key]] : [];
            list.splice(entryIndex, 1);
            row[key] = list;
            return row;
        });
    };

    const handleParallelSubjectChange = (rowData, periodIndex, entryIndex, value) => {
        const key = `Parallel${periodIndex + 1}`;
        const selected = subjectList.find(s => s?.value === value);
        const singleTeacher = selected?.TeachersList?.length === 1 ? selected.TeachersList[0]?.id : null;
        updateDayRow(rowData, (row) => {
            const list = Array.isArray(row[key]) ? row[key].map(x => ({ ...x })) : [];
            if (list[entryIndex]) { list[entryIndex].SubjectId = value; list[entryIndex].TeacherId = singleTeacher; }
            row[key] = list;
            return row;
        });
    };

    const handleParallelTeacherChange = (rowData, periodIndex, entryIndex, value) => {
        const key = `Parallel${periodIndex + 1}`;
        updateDayRow(rowData, (row) => {
            const list = Array.isArray(row[key]) ? row[key].map(x => ({ ...x })) : [];
            if (list[entryIndex]) list[entryIndex].TeacherId = value;
            row[key] = list;
            return row;
        });
    };

    const handleTeacherDropdownChange = (e, rowData, period) => {
        const updatedData = editTableData.map(row => {
            if (row?.Day === rowData?.Day) {
                return { ...row, [period]: e.value };
            }
            return row;
        });

        const sortedData = updatedData.sort((a, b) => {
            return days.indexOf(a?.Day) - days.indexOf(b?.Day);
        });

        setEditTableData(sortedData);
    };

    const saveTimeTable = async () => {
        try {
            if (CommonConfig.isEmpty(startDateValue)) {
                setStartDateValueErr(true);
                setStartDateValueErrText('Start Date is required');
                return;
            }
            const requestData = editTableData.map(row => ({
                id: row?.id,
                FinancialYearId: selectedYear,
                Day: row?.Day,
                StartDate: !CommonConfig.isEmpty(startDateValue) ? moment(startDateValue).format("YYYY-MM-DD") : '',
                EndDate: !CommonConfig.isEmpty(endDateValue) ? moment(endDateValue).format("YYYY-MM-DD") : '',
                Periods: periodsList?.map((period, index) => {
                    const isBreak = !!period?.isBreak || !!period?.Time?.includes('Break');
                    const cellVal = row[`Period${index + 1}`];
                    const isSpecial = cellVal === 'Remedial' || cellVal === 'Hobby';
                    const parallels = Array.isArray(row[`Parallel${index + 1}`]) ? row[`Parallel${index + 1}`] : [];
                    return {
                        ClassId: props?.location?.state?.ClassId,
                        Time: period?.Time,
                        SubjectId: isBreak ? 'Break' : (isSpecial ? '' : cellVal),
                        TeacherId: isBreak ? 'Break' : (isSpecial ? '' : row[`Teacher${index + 1}`]),
                        PeriodType: isSpecial ? cellVal : 'Subject',
                        ParallelSubjects: (isBreak || isSpecial)
                            ? []
                            : parallels
                                .filter(p => p?.SubjectId)
                                .map(p => ({ SubjectId: p.SubjectId, TeacherId: p.TeacherId || '' })),
                    };
                }),
                CreatedBy: securityUserID,
            }));
            const response = await api.post(APIConstant.path.AddUpdateTimeTableEntry, requestData);
            if (response.success) {
                Toast.success({ message: response?.message });
                navigate(-1);
            } else {
                Toast.error({ message: response?.message });
            }
        } catch (error) {
            console.error("Error saving timetable:", error);
            catchResponse(error);
        }
    };

    const handleEditColumnName = (type, rowIndex, value) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) =>
                index === rowIndex ? { ...item, [type]: new Date(value) } : item
            )
        );
    };

    const handleDeleteColumn = (index) => {
        const updatedPeriodsList = periodsList?.filter((_, i) => i !== index);
        const updatedTableData = editTableData.map((row) => {
            const updatedRow = { ...row };
            delete updatedRow[`Period${index + 1}`];
            return updatedRow;
        });
        setPeriodsList(updatedPeriodsList);
        setEditTableData(updatedTableData);
    };

    const handleToggleEdit = (rowIndex) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    let formattedTime = item?.Time;
                    if (item?.isEdit && item?.FromTime && item?.ToTime) {
                        const formatTime = (time) => {
                            const date = new Date(time);
                            const hours = date.getHours();
                            const minutes = date.getMinutes();
                            const ampm = hours >= 12 ? 'PM' : 'AM';
                            const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
                            const formattedMinutes = minutes.toString().padStart(2, '0');
                            return `${formattedHours}:${formattedMinutes} ${ampm}`;
                        };
                        formattedTime = `${formatTime(item.FromTime)} - ${formatTime(item.ToTime)}`;
                    }

                    return {
                        ...item,
                        isEdit: !item?.isEdit,
                        Time: formattedTime,
                    };
                }
                return {
                    ...item,
                    isEdit: false,
                };
            })
        );
    };

    const handleToggleBreak = (rowIndex, value) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    return {
                        ...item,
                        isBreak: value,
                    };
                }
                return {
                    ...item,
                };
            })
        );
        const updatedTableData = editTableData.map((row, rowIdx) => {
            const updatedRow = { ...row };
            if (value) {
                updatedRow[`Period${rowIndex + 1}`] = 'Break';
            } else {
                const originalRow = originalEditTableData?.[rowIdx];
                const originalValue = originalRow?.[`Period${rowIndex + 1}`];
                const originalTeacherValue = originalRow?.[`Teacher${rowIndex + 1}`];
                updatedRow[`Period${rowIndex + 1}`] = (originalValue === 'Break' ? '' : originalValue) ?? updatedRow[`Period${rowIndex + 1}`];
                updatedRow[`Teacher${rowIndex + 1}`] = (originalTeacherValue === 'Break' ? '' : originalTeacherValue) ?? updatedRow[`Teacher${rowIndex + 1}`];

            }
            return updatedRow;
        });
        setEditTableData(updatedTableData);
    };

    const handleAddColumn = () => {
        const newColumn = {
            Time: `New Column ${periodsList.length + 1}`,
            isEdit: true,
            isBreak: false
        };
        setPeriodsList([...periodsList, newColumn]);
        const updatedTableData = editTableData.map((row) => ({
            ...row,
            [`Period${periodsList.length + 1}`]: '',
        }));
        setEditTableData(updatedTableData);
    };

    const handleStartDateChange = (e) => {
        const selectedDate = e.value;
        setStartDateValue(selectedDate);

        if (endDateValue && selectedDate && endDateValue < selectedDate) {
            setEndDateValue(null);
        }
    };

    const handleSearch = () => {
        if (startDateValue) {
            GetTimeTableData(props?.location?.state?.ClassId, securityUserID, startDateValue, endDateValue);
        }
    };

    return (
        <div className="wayment-owner-dashboard et-master-page">
            <style>{`
                .e-class-time-table .p-datatable-thead > tr > th { background:#f4f7fb; vertical-align: top; border-bottom:2px solid #e2e8f0; }
                .e-class-time-table .p-datatable-tbody > tr > td { vertical-align: top; }
                .e-class-time-table .p-datatable-tbody > tr:nth-child(even) > td { background:#fbfcff; }
                .e-class-time-table .p-datatable-tbody > tr > td:first-child { font-weight:700; color:#1c515e; background:#eef3f9; white-space:nowrap; }
                .e-class-time-table .ett-col-head { display:flex; flex-direction:column; gap:6px; min-width:210px; }
                .e-class-time-table .ett-col-time { display:flex; align-items:center; font-weight:600; color:#334155; font-size:12.5px; }
                .e-class-time-table .ett-col-actions { display:flex; align-items:center; gap:2px; }
                .e-class-time-table .ett-break { display:inline-flex; align-items:center; gap:4px; margin-left:6px; font-size:12px; color:#64748b; }
                .e-class-time-table .dropdown-container { display:flex; flex-direction:column; gap:6px; min-width:200px; }
            `}</style>
            <div className="heading-area p-d-flex p-ai-center p-jc-between p-w-100">
                <div className="p-d-flex p-ai-baseline">
                    <i
                        className="pi pi-arrow-left"
                        style={{ cursor: 'pointer'}}
                        onClick={() => navigate('/time-table-configuration')}
                        title="Back"
                    ></i>
                    <h2>{props?.location?.state?.configId ? "Edit" : "Add"} Class Time Table</h2>
                </div>
                <div>
                    <Button
                        className="e-sction-btn p-my-2"
                        icon="pi pi-plus"
                        onClick={handleAddColumn}
                    />
                </div>
            </div>
            <div className='e-class-time-table'>
                <div className="p-grid">
                    <div className="p-col-4 p-md-3">
                        <label htmlFor="startDateTime">Start Date</label>
                        <div>
                            <Calendar
                                className="p-w-100 p-mt-0"
                                id="startDateTime"
                                onChange={handleStartDateChange}
                                placeholder="DD/MM/YYYY"
                                value={startDateValue}
                                minDate={academicStartDate}
                                maxDate={academicEndDate}
                                hideOnDateTimeSelect
                                dateFormat="dd/mm/yy"
                                style={{ height: '42px'}}
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {startDateValueErr ? startDateValueErrText : null}
                            </span>
                        </div>
                    </div>
                    <div className="p-col-4 p-md-3">
                        <label htmlFor="endDateTime">End Date</label>
                        <div>
                            <Calendar
                                className="p-w-100 p-mt-0"
                                id="endDateTime"
                                onChange={(e) => setEndDateValue(e.value)}
                                placeholder="DD/MM/YYYY"
                                hideOnDateTimeSelect
                                value={endDateValue}
                                dateFormat="dd/mm/yy"
                                minDate={CommonConfig.parseDDMMYYYYToDate(startDateValue) ?? academicStartDate}
                                maxDate={academicEndDate}
                                style={{ height: '42px'}}
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="p-d-flex p-ai-end p-jc-between p-gap-2" style={{ gap: '10px'}}>
                            <div className="custom-inputs">
                                <label htmlFor="selectedYear">Academic Years</label>
                                <Dropdown
                                    id="selectedYear"
                                    value={selectedYear}
                                    options={props?.location?.state?.academicYearList ?? []}
                                    onChange={(e) => setSelectedYear(e.value)}
                                    placeholder="Select Academic Year"
                                    display="chip"
                                    className='p-w-100'
                                    filter
                                    optionLabel="label"
                                    optionValue="_id"
                                    showClear
                                />
                            </div>
                            <div className="">
                                <Button
                                    label="Search"
                                    icon="pi pi-search"
                                    className="e-sction-btn p-w-md-auto p-mt-0 p-h-10"
                                    style={{ height: '42px'}}
                                    onClick={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {subjectList.length > 0 && (
                        <DataTable
                            value={editTableData}
                            responsiveLayout="scroll"
                            className='custom-table'
                            scrollHeight='calc(100vh - 200px)'
                            size='small'
                        >
                            <Column field="Day" header="Days/Periods" />
                            {periodsList?.map((period, index) => (
                                <Column
                                    key={index}
                                    field={`Period${index + 1}`}
                                    header={
                                        <div className="ett-col-head">
                                            <div className="ett-col-time">
                                                {period?.isEdit ? (
                                                    <>
                                                        <Calendar
                                                            value={period?.FromTime}
                                                            onChange={(e) => handleEditColumnName('FromTime', index, e.value)}
                                                            hourFormat="12"
                                                            showTime
                                                            showSeconds={false}
                                                            timeOnly
                                                            className='time-table-input'
                                                        />
                                                        <Calendar
                                                            className='p-ml-2 time-table-input'
                                                            value={period?.ToTime}
                                                            onChange={(e) => handleEditColumnName('ToTime', index, e.target.value)}
                                                            hourFormat="12"
                                                            showTime
                                                            showSeconds={false}
                                                            timeOnly
                                                        />
                                                    </>
                                                ) : (
                                                    <span className="ett-time-label">{period?.Time}</span>
                                                )}
                                            </div>
                                            <div className="ett-col-actions">
                                                <Button
                                                    icon={period?.isEdit ? "pi pi-check" : "pi pi-pencil"}
                                                    className={`p-button-text p-button-rounded p-button-sm ${period?.isEdit ? 'p-button-success' : 'p-button-secondary'}`}
                                                    tooltip={period?.isEdit ? 'Save time' : 'Edit time'}
                                                    tooltipOptions={{ position: 'top' }}
                                                    onClick={() => handleToggleEdit(index)}
                                                />
                                                <Button
                                                    icon="pi pi-trash"
                                                    className="p-button-text p-button-rounded p-button-sm p-button-danger"
                                                    tooltip="Remove period"
                                                    tooltipOptions={{ position: 'top' }}
                                                    onClick={() => handleDeleteColumn(index)}
                                                />
                                                <span className="ett-break">
                                                    <Checkbox
                                                        inputId={`break-${index}`}
                                                        checked={period?.isBreak}
                                                        onChange={(e) => handleToggleBreak(index, e.checked)}
                                                    />
                                                    <label htmlFor={`break-${index}`}>Break</label>
                                                </span>
                                            </div>
                                        </div>
                                    }
                                    body={(rowData) => {
                                        if (rowData[`Period${index + 1}`] === 'Break') {
                                            return rowData[`Period${index + 1}`];
                                        }
                                        const periodVal = rowData[`Period${index + 1}`];
                                        const isSpecial = periodVal === 'Remedial' || periodVal === 'Hobby';
                                        const periodType = isSpecial ? periodVal : 'Normal';
                                        const showParallel = !!periodVal && periodVal !== 'Break' && !isSpecial;
                                        const parallelList = Array.isArray(rowData[`Parallel${index + 1}`]) ? rowData[`Parallel${index + 1}`] : [];
                                        return (
                                            <div className="dropdown-container">
                                                <Dropdown
                                                    value={periodType}
                                                    options={[{ label: 'Subject', value: 'Normal' }, { label: 'Remedial Class', value: 'Remedial' }, { label: 'Hobby Class', value: 'Hobby' }]}
                                                    onChange={(e) => handlePeriodTypeChange(rowData, index, e.value)}
                                                    style={{ width: '100%', marginBottom: '4px' }}
                                                />
                                                {!isSpecial && (
                                                    <Dropdown
                                                        value={periodVal}
                                                        options={subjectList}
                                                        onChange={(e) =>
                                                            handleDropdownChange(e, rowData, `Period${index + 1}`)
                                                        }
                                                        placeholder="Select Subject"
                                                        style={{ width: '100%' }}
                                                        filter
                                                        showClear
                                                    />
                                                )}
                                                {!isSpecial && (
                                                    <Dropdown
                                                        value={rowData[`Teacher${index + 1}`]}
                                                        options={subjectList.filter(x => x?.value === rowData[`Period${index + 1}`] ?? '').length ? subjectList.filter(x => x?.value === rowData[`Period${index + 1}`] ?? '')[0]?.TeachersList : []}
                                                        optionLabel='Name'
                                                        optionValue='id'
                                                        onChange={(e) => handleTeacherDropdownChange(e, rowData, `Teacher${index + 1}`)}
                                                        placeholder="Select Teacher"
                                                        className="dropdown"
                                                        filter
                                                        showClear
                                                    />
                                                )}
                                                {showParallel && (
                                                    <div style={{ marginTop: '6px' }}>
                                                        <div style={{ fontSize: '11px', color: '#6B7794', marginBottom: '2px' }}>Additional subjects</div>
                                                        {parallelList.map((entry, ei) => {
                                                            const chosen = [rowData[`Period${index + 1}`], ...parallelList.map((x, xi) => (xi !== ei ? x?.SubjectId : null))].filter(Boolean);
                                                            const opts = subjectList.filter(s => !chosen.includes(s.value));
                                                            const teacherOpts = subjectList.find(s => s?.value === entry?.SubjectId)?.TeachersList || [];
                                                            return (
                                                                <div key={ei} style={{ display: 'flex', gap: '4px', alignItems: 'center', marginBottom: '4px' }}>
                                                                    <Dropdown
                                                                        value={entry?.SubjectId || null}
                                                                        options={opts}
                                                                        onChange={(e) => handleParallelSubjectChange(rowData, index, ei, e.value)}
                                                                        placeholder="Subject"
                                                                        style={{ flex: 1, minWidth: 0 }}
                                                                        filter
                                                                        showClear
                                                                    />
                                                                    <Dropdown
                                                                        value={entry?.TeacherId || null}
                                                                        options={teacherOpts}
                                                                        optionLabel='Name'
                                                                        optionValue='id'
                                                                        onChange={(e) => handleParallelTeacherChange(rowData, index, ei, e.value)}
                                                                        placeholder="Teacher"
                                                                        style={{ flex: 1, minWidth: 0 }}
                                                                        filter
                                                                        showClear
                                                                    />
                                                                    <Button icon="pi pi-times" className="p-button-text p-button-danger p-p-0" onClick={() => removeParallelSubject(rowData, index, ei)} />
                                                                </div>
                                                            );
                                                        })}
                                                        <Button label="Add Subject" icon="pi pi-plus" className="p-button-text p-button-sm" onClick={() => addParallelSubject(rowData, index)} />
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    }
                                />
                            ))}
                        </DataTable>
                    )}
                </div>
                <div className='p-d-flex p-jc-end'>
                    <Button
                        className="btn-text-action-primary color-white p-mt-2"
                        label="Update"
                        severity="secondary"
                        raised
                        onClick={(e) => saveTimeTable()}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditClassTimeTable;
